// 线索管理 - L3
const config = {
    'leadImportManage': { // 线索导入 - L4
        'bigData-btn-lead-import-list-search': '线索管理，线索导入-列表，搜索', // 搜索列表-按钮 L6
        'bigData-btn-lead-import-list-import': '线索管理，线索导入-导入', // 导入-按钮 L6
        'bigData-btn-lead-import-list-export': '客户账号管理,客户账号管理-账号列表,,查看账号', // 导出-按钮 L6
        'bigData-btn-lead-import-list-generate': '线索管理，线索导入-生成线索', // 生成线索-按钮 L6
        'bigData-btn-lead-import-list-abandoned': '线索管理，线索导入-废弃线索', // 废弃线索-按钮 L6
        'bigData-btn-lead-import-list-row-generate': '线索管理，线索导入-行操作-生成线索', // 生成线索-行操作按钮 L6
        'bigData-btn-lead-import-list-row-abandoned': '线索管理，线索导入-行操作-废弃线索' // 废弃线索-行操作按钮 L6
    }
};

export default config;
